import ContextualAddinCommand from './ContextualAddinCommand';
import EvaluationResult from './interfaces/EvaluationResult';
import { ObservableMap } from 'mobx';

export interface ExtensibilityHostItem {
    contextualTerms: ObservableMap<string, ContextualAddinCommand[]>;
    contextualEvaluationResults: ObservableMap<string, EvaluationResult>;
}

export function createExtensibilityHostItem(): ExtensibilityHostItem {
    return {
        contextualTerms: null,
        contextualEvaluationResults: null,
    };
}
